/**
 * Arraify facets in order to use single or multiple facets in a react component
 * @param {string|array} facets - the facets we want to apply to the component
 * @param {string} prefix - facet root class
 * @returns {Array}
 */
export default function mapFacets(facets, prefix) {
    if (facets) {
        return (Array.isArray(facets) ? facets : [facets]).map(f => `${ prefix }__${ f }`);
    }
    return [];
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/react/facet.js